<script setup lang="ts">
import type { DateRange } from "reka-ui";
import { PopoverClose, DialogClose } from "reka-ui";
import { RangeCalendar } from "@/components/ui/range-calendar";

const { t, locale } = useI18n();
defineProps<{
    isDialog?: boolean;
}>();
const value = defineModel<DateRange>({
    required: true,
});
const emit = defineEmits(["clear"]);
</script>

<template>
    <RangeCalendar
        initial-focus
        :number-of-months="1"
        :locale="locale"
        v-model="value"
        @update:start-value="(startDate) => (value.start = startDate)"
    />
    <div class="flex items-center justify-between gap-2 px-6 py-4 font-bold">
        <div
            class="flex flex-1 flex-col items-stretch gap-2"
            v-if="value.start"
        >
            <AtomsBody3>{{ t("toolbar.date.start") }}</AtomsBody3>
            <AtomsPlaceholder
                lang="en"
                class="min-h-6 rounded-full border border-base-grey px-4 py-2"
            >
                {{ value.start }}
            </AtomsPlaceholder>
        </div>
        <div
            v-if="value.start && value.end"
            class="h-5 w-3 self-end border-t border-base-grey lg:h-[22px]"
        />
        <div class="flex flex-1 flex-col items-stretch gap-2" v-if="value.end">
            <AtomsBody3>{{ t("toolbar.date.end") }}</AtomsBody3>
            <AtomsPlaceholder
                lang="en"
                class="min-h-6 rounded-full border border-base-grey px-4 py-2"
            >
                {{ value.end }}
            </AtomsPlaceholder>
        </div>
    </div>
    <div class="flex items-center justify-between gap-2 p-3">
        <template v-if="isDialog">
            <DialogClose class="btn whitespace-nowrap bg-base-doveGrey">
                <SvgArrowBackAngle24
                    class="h-[6.1vw] w-[6.1vw] xs:h-6 xs:w-6"
                />
                {{ t("toolbar.date.back") }}
            </DialogClose>
            <DialogClose class="btn bg-base-doveGrey" @click="emit('clear')">
                {{ t("toolbar.date.clear") }}
            </DialogClose>
            <DialogClose class="btn bg-primary-orange">
                {{ t("toolbar.date.confirm") }}
            </DialogClose>
        </template>
        <template v-else>
            <PopoverClose class="btn bg-base-doveGrey" @click="emit('clear')">
                {{ t("toolbar.date.clear") }}
            </PopoverClose>
            <PopoverClose class="btn bg-primary-orange">
                {{ t("toolbar.date.confirm") }}
            </PopoverClose>
        </template>
    </div>
</template>

<style scoped>
.btn {
    @apply flex h-[12.21vw] flex-1 items-center justify-center gap-2 rounded-full px-5 text-xs font-bold transition-transform duration-300 ease-in-out [will-change:transform] xs:h-[48px] sm:text-sm sm:hover:scale-[1.03] lg:gap-[0.49vw] xl:gap-[0.4vw] 3xl:gap-[8px];
}
</style>
